import React from 'react';

import { NumericTextBox } from '@progress/kendo-react-inputs';
import { FloatingLabel } from '@progress/kendo-react-labels';

import clsx from 'clsx';

import * as classes from './BobInputField.module.css';

const BobNumericInputField = ({
    className,
    rounded,
    fillMode,
    id,
    label,
    name,
    onChange,
    onBlur,
    errors,
    touched,
    size,
    value,
    ...props
}) => {

    return (
        <FloatingLabel
            className={errors ? classes.ErrorLabel : null}
            style={{ fontSize: '1.2rem' }}
            label={label}
            editorId={id}
            editorValue={value}
        >
            <NumericTextBox
                className={errors ? clsx(classes.Error, className) : clsx(classes.Input, className)}
                fillMode={fillMode}
                id={id}
                rounded={rounded}
                size={size}
                value={value}
                onBlur={(event) => onBlur(event, name)}
                onChange={(event) => onChange(event, name)}
                name={name}
            />
        </FloatingLabel>
    );
};

export default BobNumericInputField;
